import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { get } from 'lodash'
import { makeAutoObservable, runInAction } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import { FormatAPIs } from 'Services/FeelGreat/FormatAPIs'
import TrackingEvents from 'Services/Tracker/TrackingEvents'
import { createDataLayerItem, trackPurchase } from 'Services/Tracker/DataLayerTrackingEvents'
import Payment from '../Payment'
import { PaymentAPIs } from '../PaymentServices/PaymentAPI'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeCredit from 'GlobalStores/StoreCredit'
import Cities from 'Components/Elements/Forms/StatesModal/Country/TaiwanCities.json'
import { objectToQueryString } from 'Helpers/GlobalHelpers'
import storeFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'
import storeFormat from 'GlobalStores/Format/StoreFormat'

class Taiwan {
    autoAddressDisplayKeys = ['street', 'locality', 'postal_code']
    autoAddressKeyToForm = {
        street: 'street_address',
        locality: 'city',
        administrative_area: 'state',
        postal_code: 'zip_code'
    }

    uuid = ''

    toFormat = {
        enroll: {
            uuid: this.GetUuid(),
            fullName: '',
            address: '',
            city: '',
            zip: '',
            email: '',
            phone: '',
            password: ''
        },
        enrollWithReferral: {
            uuid: this.GetUuid(),
            fullName: '',
            address: '',
            city: '',
            zip: '',
            email: '',
            phone: '',
            password1: '',
            password2: ''
        },
        shop: {
            uuid: this.GetUuid(),
            fullname: '',
            city: '',
            zip: '',
            email: '',
            address1: ''
        }
    }

    formShop = {
        fullName: '',
        email: '',
        phone: '',
        street_address: '',
        city: '',
        zip_code: ''
    }

    // ok
    createAccountWithShippingAddress = {
        type: 'enroll',
        referral_id: '',
        firstname_en: '',
        lastname_en: '',
        email: '',
        phone: '',
        password: '',
        // street_address: '',
        city: '',
        zip: '',
        period: ''
    }

    ExcludedFieldsShippingIfCreateAccount = ['fullName']

    ExcludedFieldsShipping = []

    // ok -> mapping for send to api
    mapFormKeyToFormatKey = {
        street_address: 'address1',
        zip_code: 'zip',
        firstname: 'firstname_en',
        lastname: 'lastname_en'
    }

    ArrangeCreateCheckoutForm = ['firstname', 'lastname', 'email', 'password', 'phone', 'country', 'street_address', 'city', 'zip_code']

    PaymentStep = {
        payment: 0,
        createOrder: 0,
        autoship: -2,
        updateLog: 0
    }

    paymentMethod = ''

    breadcrumbOption = [
        {
            caption: 'customise',
            link: '/products',
            paramsRequire: false
        },
        {
            caption: 'signup_shipping',
            link: '/checkout/create-account',
            paramsRequire: true,
            authCaption: 'shipping',
            authLink: '/checkout/shipping'
        },
        {
            caption: 'billing',
            link: '/checkout/payment',
            paramsRequire: true
        },
        {
            caption: 'purchase',
            link: '/checkout/review',
            paramsRequire: true
        }
    ]

    shippingMethods = [
        {
            id: 1,
            api_value: 'delivery',
            title: 'standard_delivery',
            dict_key: 'standard_delivery',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'Credit card',
                    dict_key: 'creditcard',
                    for_status: [],
                    value: 'creditcard',
                    descripion: { title: '', dict_key: '' },
                    icon: 'creditcard-icon'
                },
                {
                    id: 2,
                    title: 'Cash on Delivery',
                    dict_key: 'cash_on_delivery',
                    for_status: [],
                    value: 'cashOnDelivery',
                    descripion: { title: 'pay_when_you_receive', dict_key: 'pay_when_you_receive' },
                    icon: ''
                }
            ]
        },
    ]

    orderSummaryConfig = {
        subTotal: {
            display: true,
            dict_key: 'subtotal'
        },
        shipping: {
            display: true,
            dict_key: 'shipping'
        },
        productCredit: {
            display: true,
            dict_key: 'product_credit',
            icon: true,
            allowToUse: []
        },
        vat: {
            display: false,
            dict_key: 'vat',
            value: 0.2 // 20%
        },
        shippingWithoutMethod: {
            display: true,
            displayStep: ['create-account', 'shipping', 'payment', 'review'],
            dict_key: 'shipping'
        }
    }

    landingLayouts = [
        {
            nameComponent: 'banner',
            titleContent: 'mainBanner',
            style: {}
        },
        {
            nameComponent: 'ourApproach',
            titleContent: 'ourApproach',
            style: {
                minHeight: '0px'
            }
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {
                backgroundColor: '#F1F6FB'
            }
        },
        {
            nameComponent: 'thePractice',
            titleContent: 'thePractice',
            style: {}
        },
        {
            nameComponent: 'howItWorks',
            titleContent: 'howItWorks',
            style: {
                backgroundColor: '#FBF7F1'
            }
        },
        {
            nameComponent: 'whatExpertsSay',
            titleContent: 'expertsSay',
            style: {}
        },
        {
            nameComponent: 'realResults',
            titleContent: 'realResults',
            style: {
                backgroundColor: '#F2F9F8'
            }
        }
    ]

    productLayouts = [
        {
            nameComponent: 'productDetailSelection',
            titleContent: 'productDetailSelection',
            style: {}
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {}
        },
        {
            nameComponent: 'frequentlyAskedQuestions',
            titleContent: 'questions',
            style: {
                backgroundColor: '#F6F9FC'
            }
        }
    ]

    cityOptionList = null

    MapAutoAddressToForm(form, autoAddressData) {
        const swappedValuesAsKeys = ObjectHelpers.swapKeysAndValues(this.autoAddressKeyToForm)
        return form.map(item => {
            if (swappedValuesAsKeys[item.key]) {
                if (autoAddressData.data) {
                    item.value = autoAddressData.data[swappedValuesAsKeys[item.key]]
                }
            }

            return item
        })
    }

    FormToFormat(type, form) {
        form.map(item => {
            if (this.mapFormKeyToFormatKey[item.key]) {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][this.mapFormKeyToFormatKey[item.key]] = item.value
                    })
                }
            } else {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][item.key] = item.value
                    })
                }
            }

            return item
        })
    }

    SetUuid(value) {
        this.uuid = value
    }

    GetUuid() {
        return this.uuid
    }

    GetFormat(type) {
        return this.toFormat[type]
    }

    GetPaymentStep() {
        return this.PaymentStep
    }

    GetBreadcrumbOption() {
        return this.breadcrumbOption
    }

    GetShippingMethod() {
        return this.shippingMethods
    }

    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    SetPaymentStep(key, value) {
        this.PaymentStep[key] = value
    }

    GetShippingMethod() {
        return this.shippingMethods
    }

    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    GetLandingLayout() {
        return this.landingLayouts
    }

    GetProductLayout() {
        return this.productLayouts
    }

    GetPaymentMethod() {
        return this.paymentMethod
    }

    SetPaymentMethod(value) {
        runInAction(() => {
            this.paymentMethod = value
        })
    }

    /**
     *
     * @param {*} uuid
     * @param {object} detailPage { products, detailPage, isSubscribe, isEnroll, type}
     * @param {*} CreditCardEncrypted
     */
    async SubmitPayment(uuid, detailPage, CreditCardEncrypted, products) {
        const Pay = new Payment(uuid, detailPage)
        try {
            const responsePreparePayment = await Pay.PreparePaymentData()

            const allowCreditEnable = StoreAuth.IsAllowCredit()

            if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                Pay.hydra.transactions = {
                    items: [CreditCardEncrypted, storeCredit.ProductCreditUsed()]
                }
            } else {
                Pay.hydra.transactions = {
                    items: [CreditCardEncrypted]
                }
            }

            await Pay.PostToHydra()

            Pay.SendEmail()
            Pay.SendSms()

            await Pay.UpdateToLog(Pay.hydra.transactions)

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            try {
                TrackingEvents.PurchaseEvent({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    value: Pay.ushop.total_price,
                    currency: 'TWD',
                    category: Pay.ushop.shipment_purchas_option,
                    items: products
                })
                trackPurchase({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    currency: 'TWD',
                    value: Pay.ushop.total_price,
                    items: Array.isArray(products) ? products.map(item => createDataLayerItem(item)) : []
                })
            } catch (e) {
                console.error('TrackingEvents.PurchaseEvent', e)
            }
            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.error(error)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            Pay.UpdateToLog(Pay.hydra.transactions, 0, true)

            return { success: false }
        }
    }

    async SubmitCashOnDeliveryPayment(uuid, detailPage, products) {
        try {
            const data = {
                uuid: uuid,
                payment_options: 'cashondelivery',
                shipment_packs: JSON.stringify(storeCheckout.GetCart())
            }

            const responseFormat = await FormatAPIs.putHotFormatV2(data, storeCountry.Country3())
            if (responseFormat) {
                const PayCOD = new Payment(uuid, detailPage)
                await PayCOD.PreparePaymentData()

                const result = await PayCOD.SubmitOneTimePayment({
                    payments: [{ method: 'cashOnDelivery', amount: PayCOD.ushop.total_price }]
                })

                if (!result?.success) {
                    runInAction(() => {
                        StorePaymentStep.PaymentDone = true
                    })
                    return { success: false }
                }

                PayCOD.SendEmailV4()

                const hasSubscribe = /subscribe/i.test(detailPage.shipment_packs)
                await PayCOD.UpdateToLog(PayCOD.hydra.transactions, hasSubscribe ? 1 : 0, false, 'success')

                runInAction(() => {
                    StorePaymentStep.PaymentDone = true
                })

                try {
                    TrackingEvents.PurchaseEvent({
                        transaction_id: result.referenceNo,
                        value: PayCOD.ushop.total_price,
                        currency: 'TWD',
                        category: PayCOD.ushop.shipment_purchas_option,
                        items: products
                    })
                    trackPurchase({
                        transaction_id: result.referenceNo,
                        currency: 'TWD',
                        value: PayCOD.ushop.total_price,
                        items: Array.isArray(products) ? products.map(item => createDataLayerItem(item)) : []
                    })
                } catch (e) {
                    console.error('TrackingEvents.PurchaseEvent', e)
                }

                return {
                    success: true,
                    gateway_ref_id: result.referenceNo
                }
            }
        } catch (error) {
            console.error(error)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            return { success: false }
        }
    }

    async CreateAccount(uuid, accForm, shippingForm, referral, cartItems) {
        try {
            const forms = Object.assign(this.createAccountWithShippingAddress, accForm)
            const returnShippingAddress = {}

            shippingForm.forEach(item => {
                if (this.ExcludedFieldsShippingIfCreateAccount.includes(item.key)) {
                    return false
                }
                if (this.mapFormKeyToFormatKey[item.key]) {
                    forms[this.mapFormKeyToFormatKey[item.key]] = item.value
                    returnShippingAddress[this.mapFormKeyToFormatKey[item.key]] = item.value
                } else {
                    forms[item.key] = item.value
                    returnShippingAddress[item.key] = item.value
                }
            })

            if (referral) {
                forms.referral_id = referral
            } else {
                delete forms.referral_id
            }

            delete forms.country

            const periodResponse = await FeelGreatAPI.GetPeriod('TW')
            forms.period = periodResponse.data.entryPeriod
            forms.uuid = uuid
            forms.shipment_packs = JSON.stringify(cartItems)
            // auto address return some address's zip code be 5 digits but BE need 3 digits
            if (forms?.zip && forms?.zip?.length === 5) {
                forms.zip = forms.zip.slice(0, 3)
            }

            const queryStrings = objectToQueryString({
                dev: ServerEnv.ENV === 'DEV' ? '1' : undefined,
                emailDelay: ServerEnv.ENV === 'DEV' ? undefined : '1h',
                isSkipCheckPassword: storeFeelGreat.passwordSettings.isUseComplexPassword ? '1' : undefined,
            })

            const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/TWN/feelGreat/createAccount${queryStrings}`
            const response = await axios.post(url, forms)

            return {
                ...response.data,
                form: forms
            }
        } catch (e) {
            console.error(e)

            return {
                success: false
            }
        }
    }

    SpecialAreasDeliveryFeeCondition(step) {
        return storeFormat.GetFreight()
    }

    setCityOptionList(isSwitchLanguage = false) {
        if (this.cityOptionList !== null && isSwitchLanguage === false) return

        let options = []
        if (Cities.length > 0) {
            const isEng = localStorage.getItem('currentLanguage') === 'EN'
            const optionLanguage = isEng ? 'city_roman' : 'city_native'

            options = Cities.map(item => {
                return {
                    text: item[`${optionLanguage}`],
                    value: item[`${optionLanguage}`],
                    html: `<span>${item[`${optionLanguage}`]}</span>`
                }
            })
        }
        this.cityOptionList = options

        return
    }

    getCityOptionList() {
        return this.cityOptionList
    }

    pageConfig = {
        signUp: {
            disable: true
        }
    }

    GetPageConfig() {
        return this.pageConfig
    }

    constructor() {
        StorePaymentStep.SetPaymentSteps(this.PaymentStep)
        this.setCityOptionList()
        makeAutoObservable(this)
    }
}

export default Taiwan
